import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-full m-3 mb-0 p-3 pb-0 text-sm text-600"
}
const _hoisted_2 = { class: "add-goal-button" }

import { ref, toRef } from 'vue';
import { AxiosResponse } from 'axios';
import Goal from './Goal.vue';
import { TreatmentGoalFormInterface } from '@/types/TreatmentPlans';
import useUserTreatmentPlanStore from '@/store/People/Person/TreatmentPlans';
import { EMIT, PERMISSIONS } from '@/enum';
import { can } from '@/composables';

interface Props {
  goals: TreatmentGoalFormInterface[];
  serviceId: number;
  loading?: boolean;
  parentElement: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ServiceGoals',
  props: {
    goals: {},
    serviceId: {},
    loading: { type: Boolean },
    parentElement: {}
  },
  emits: [EMIT.REMOVE, EMIT.NEW_GOAL, EMIT.SUCCESS, EMIT.UPDATE, EMIT.ERROR],
  setup(__props: any, { emit: __emit }) {

const treatmentPlansStore = useUserTreatmentPlanStore();
const props = __props;
const emit = __emit;
const goals = toRef(props, 'goals');
const newGoals = ref<TreatmentGoalFormInterface[]>([]);

const addEmptyGoal = () => {
  newGoals.value.push({
    description: '',
    newGoalId: Math.random(),
  });
  setTimeout(() => {
    const serviceScroll = document.getElementById(props.parentElement);
    if (serviceScroll) serviceScroll.scrollTop = serviceScroll.scrollHeight;
  }, 100);
};

const onGoalRemoved = async (editedGoal: TreatmentGoalFormInterface) => {
  /**
   * if there is a goalId then the goal has been saved on the API, if not it was just created
   * and therefore we dont need to delete on the server, so just pop it off the goals array
   */
  await treatmentPlansStore
    .deleteGoal({ treatment_goals: [editedGoal.id] as number[] })
    .then(onRemoveSuccess)
    .catch(onRemoveFailed);
};

const onNewGoalRemove = (newGoal: TreatmentGoalFormInterface) => {
  newGoals.value = newGoals.value.filter((a) => a.newGoalId !== newGoal.newGoalId);
};

const onGoalUpdate = (msg: string) => emit(EMIT.UPDATE, msg);

const onGoalError = (msg: string) => emit(EMIT.ERROR, msg);

const onGoalSuccess = (msg: string) => emit(EMIT.SUCCESS, msg);

const onRemoveSuccess = () => emit(EMIT.REMOVE);

const onRemoveFailed = (error: AxiosResponse) => emit(EMIT.ERROR, error.data.message);

const onNewGoal = (goal: TreatmentGoalFormInterface) => {
  emit(EMIT.NEW_GOAL);
  onNewGoalRemove(goal);
};

return (_ctx: any,_cache: any) => {
  const _component_AppButton = _resolveComponent("AppButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goals.value, (goal) => {
      return (_openBlock(), _createElementBlock("div", {
        key: goal.id,
        class: _normalizeClass(["flex flex-column", { 'pr-3': goals.value.length + newGoals.value.length < 3 }])
      }, [
        _createVNode(Goal, {
          goal: goal,
          "service-id": __props.serviceId,
          onRemove: onGoalRemoved,
          onNewGoal: onNewGoal,
          onUpdate: onGoalUpdate,
          onError: onGoalError,
          onSuccess: onGoalSuccess
        }, null, 8, ["goal", "service-id"])
      ], 2))
    }), 128)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(newGoals.value, (goal) => {
      return (_openBlock(), _createElementBlock("div", {
        key: goal.newGoalId,
        class: _normalizeClass(["flex flex-column", { 'pr-3': goals.value.length + newGoals.value.length < 3 }])
      }, [
        _createVNode(Goal, {
          goal: goal,
          "service-id": __props.serviceId,
          onRemove: onNewGoalRemove,
          onNewGoal: onNewGoal,
          onUpdate: onGoalUpdate,
          onError: onGoalError,
          onSuccess: onGoalSuccess
        }, null, 8, ["goal", "service-id"])
      ], 2))
    }), 128)),
    (!goals.value.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[0] || (_cache[0] = [
          _createElementVNode("span", null, "No goals have been added to this service", -1)
        ]))]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_unref(can)([_unref(PERMISSIONS).TREATMENT_SERVICES_GOALS_STORE]))
        ? (_openBlock(), _createBlock(_component_AppButton, {
            key: 0,
            type: "secondary",
            "icon-left": "add",
            text: "Add Goal",
            onClick: addEmptyGoal
          }))
        : _createCommentVNode("", true)
    ])
  ], 64))
}
}

})